<ng-container *ngIf="showErr">
  <com-error [errList]="errList"></com-error>
</ng-container>